/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WalletRouteImport } from './routes/wallet'
import { Route as UpgradeRouteImport } from './routes/upgrade'
import { Route as TopupRouteImport } from './routes/topup'
import { Route as SubscriptionRouteImport } from './routes/subscription'
import { Route as StatusRouteImport } from './routes/status'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ReferralWithdrawRouteImport } from './routes/referral-withdraw'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as PaymentsRouteImport } from './routes/payments'
import { Route as MeRouteImport } from './routes/me'
import { Route as LocationsRouteImport } from './routes/locations'
import { Route as GiveawaysRouteImport } from './routes/giveaways'
import { Route as GiftRouteImport } from './routes/gift'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DevicesRouteImport } from './routes/devices'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SuccessSubscriptionIdRouteImport } from './routes/success.$subscriptionId'
import { Route as RenewSubscriptionIdRouteImport } from './routes/renew.$subscriptionId'
import { Route as ProcessingPaymentIdRouteImport } from './routes/processing.$paymentId'
import { Route as CountriesSubscriptionIdRouteImport } from './routes/countries.$subscriptionId'
import { Route as CheckoutPlanIdRouteImport } from './routes/checkout.$planId'

const WalletRoute = WalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => rootRouteImport,
} as any)
const UpgradeRoute = UpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => rootRouteImport,
} as any)
const TopupRoute = TopupRouteImport.update({
  id: '/topup',
  path: '/topup',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionRoute = SubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewsRoute = ReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferralWithdrawRoute = ReferralWithdrawRouteImport.update({
  id: '/referral-withdraw',
  path: '/referral-withdraw',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PlansRoute = PlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsRoute = PaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRoute = MeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationsRoute = LocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => rootRouteImport,
} as any)
const GiveawaysRoute = GiveawaysRouteImport.update({
  id: '/giveaways',
  path: '/giveaways',
  getParentRoute: () => rootRouteImport,
} as any)
const GiftRoute = GiftRouteImport.update({
  id: '/gift',
  path: '/gift',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const DevicesRoute = DevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SuccessSubscriptionIdRoute = SuccessSubscriptionIdRouteImport.update({
  id: '/success/$subscriptionId',
  path: '/success/$subscriptionId',
  getParentRoute: () => rootRouteImport,
} as any)
const RenewSubscriptionIdRoute = RenewSubscriptionIdRouteImport.update({
  id: '/renew/$subscriptionId',
  path: '/renew/$subscriptionId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProcessingPaymentIdRoute = ProcessingPaymentIdRouteImport.update({
  id: '/processing/$paymentId',
  path: '/processing/$paymentId',
  getParentRoute: () => rootRouteImport,
} as any)
const CountriesSubscriptionIdRoute = CountriesSubscriptionIdRouteImport.update({
  id: '/countries/$subscriptionId',
  path: '/countries/$subscriptionId',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutPlanIdRoute = CheckoutPlanIdRouteImport.update({
  id: '/checkout/$planId',
  path: '/checkout/$planId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/devices': typeof DevicesRoute
  '/faq': typeof FaqRoute
  '/gift': typeof GiftRoute
  '/giveaways': typeof GiveawaysRoute
  '/locations': typeof LocationsRoute
  '/me': typeof MeRoute
  '/payments': typeof PaymentsRoute
  '/plans': typeof PlansRoute
  '/profile': typeof ProfileRoute
  '/referral-withdraw': typeof ReferralWithdrawRoute
  '/reviews': typeof ReviewsRoute
  '/settings': typeof SettingsRoute
  '/status': typeof StatusRoute
  '/subscription': typeof SubscriptionRoute
  '/topup': typeof TopupRoute
  '/upgrade': typeof UpgradeRoute
  '/wallet': typeof WalletRoute
  '/checkout/$planId': typeof CheckoutPlanIdRoute
  '/countries/$subscriptionId': typeof CountriesSubscriptionIdRoute
  '/processing/$paymentId': typeof ProcessingPaymentIdRoute
  '/renew/$subscriptionId': typeof RenewSubscriptionIdRoute
  '/success/$subscriptionId': typeof SuccessSubscriptionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/devices': typeof DevicesRoute
  '/faq': typeof FaqRoute
  '/gift': typeof GiftRoute
  '/giveaways': typeof GiveawaysRoute
  '/locations': typeof LocationsRoute
  '/me': typeof MeRoute
  '/payments': typeof PaymentsRoute
  '/plans': typeof PlansRoute
  '/profile': typeof ProfileRoute
  '/referral-withdraw': typeof ReferralWithdrawRoute
  '/reviews': typeof ReviewsRoute
  '/settings': typeof SettingsRoute
  '/status': typeof StatusRoute
  '/subscription': typeof SubscriptionRoute
  '/topup': typeof TopupRoute
  '/upgrade': typeof UpgradeRoute
  '/wallet': typeof WalletRoute
  '/checkout/$planId': typeof CheckoutPlanIdRoute
  '/countries/$subscriptionId': typeof CountriesSubscriptionIdRoute
  '/processing/$paymentId': typeof ProcessingPaymentIdRoute
  '/renew/$subscriptionId': typeof RenewSubscriptionIdRoute
  '/success/$subscriptionId': typeof SuccessSubscriptionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/devices': typeof DevicesRoute
  '/faq': typeof FaqRoute
  '/gift': typeof GiftRoute
  '/giveaways': typeof GiveawaysRoute
  '/locations': typeof LocationsRoute
  '/me': typeof MeRoute
  '/payments': typeof PaymentsRoute
  '/plans': typeof PlansRoute
  '/profile': typeof ProfileRoute
  '/referral-withdraw': typeof ReferralWithdrawRoute
  '/reviews': typeof ReviewsRoute
  '/settings': typeof SettingsRoute
  '/status': typeof StatusRoute
  '/subscription': typeof SubscriptionRoute
  '/topup': typeof TopupRoute
  '/upgrade': typeof UpgradeRoute
  '/wallet': typeof WalletRoute
  '/checkout/$planId': typeof CheckoutPlanIdRoute
  '/countries/$subscriptionId': typeof CountriesSubscriptionIdRoute
  '/processing/$paymentId': typeof ProcessingPaymentIdRoute
  '/renew/$subscriptionId': typeof RenewSubscriptionIdRoute
  '/success/$subscriptionId': typeof SuccessSubscriptionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/devices'
    | '/faq'
    | '/gift'
    | '/giveaways'
    | '/locations'
    | '/me'
    | '/payments'
    | '/plans'
    | '/profile'
    | '/referral-withdraw'
    | '/reviews'
    | '/settings'
    | '/status'
    | '/subscription'
    | '/topup'
    | '/upgrade'
    | '/wallet'
    | '/checkout/$planId'
    | '/countries/$subscriptionId'
    | '/processing/$paymentId'
    | '/renew/$subscriptionId'
    | '/success/$subscriptionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/devices'
    | '/faq'
    | '/gift'
    | '/giveaways'
    | '/locations'
    | '/me'
    | '/payments'
    | '/plans'
    | '/profile'
    | '/referral-withdraw'
    | '/reviews'
    | '/settings'
    | '/status'
    | '/subscription'
    | '/topup'
    | '/upgrade'
    | '/wallet'
    | '/checkout/$planId'
    | '/countries/$subscriptionId'
    | '/processing/$paymentId'
    | '/renew/$subscriptionId'
    | '/success/$subscriptionId'
  id:
    | '__root__'
    | '/'
    | '/activity'
    | '/devices'
    | '/faq'
    | '/gift'
    | '/giveaways'
    | '/locations'
    | '/me'
    | '/payments'
    | '/plans'
    | '/profile'
    | '/referral-withdraw'
    | '/reviews'
    | '/settings'
    | '/status'
    | '/subscription'
    | '/topup'
    | '/upgrade'
    | '/wallet'
    | '/checkout/$planId'
    | '/countries/$subscriptionId'
    | '/processing/$paymentId'
    | '/renew/$subscriptionId'
    | '/success/$subscriptionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityRoute: typeof ActivityRoute
  DevicesRoute: typeof DevicesRoute
  FaqRoute: typeof FaqRoute
  GiftRoute: typeof GiftRoute
  GiveawaysRoute: typeof GiveawaysRoute
  LocationsRoute: typeof LocationsRoute
  MeRoute: typeof MeRoute
  PaymentsRoute: typeof PaymentsRoute
  PlansRoute: typeof PlansRoute
  ProfileRoute: typeof ProfileRoute
  ReferralWithdrawRoute: typeof ReferralWithdrawRoute
  ReviewsRoute: typeof ReviewsRoute
  SettingsRoute: typeof SettingsRoute
  StatusRoute: typeof StatusRoute
  SubscriptionRoute: typeof SubscriptionRoute
  TopupRoute: typeof TopupRoute
  UpgradeRoute: typeof UpgradeRoute
  WalletRoute: typeof WalletRoute
  CheckoutPlanIdRoute: typeof CheckoutPlanIdRoute
  CountriesSubscriptionIdRoute: typeof CountriesSubscriptionIdRoute
  ProcessingPaymentIdRoute: typeof ProcessingPaymentIdRoute
  RenewSubscriptionIdRoute: typeof RenewSubscriptionIdRoute
  SuccessSubscriptionIdRoute: typeof SuccessSubscriptionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wallet': {
      id: '/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof WalletRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upgrade': {
      id: '/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof UpgradeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/topup': {
      id: '/topup'
      path: '/topup'
      fullPath: '/topup'
      preLoaderRoute: typeof TopupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription': {
      id: '/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof SubscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reviews': {
      id: '/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof ReviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referral-withdraw': {
      id: '/referral-withdraw'
      path: '/referral-withdraw'
      fullPath: '/referral-withdraw'
      preLoaderRoute: typeof ReferralWithdrawRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plans': {
      id: '/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments': {
      id: '/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof PaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locations': {
      id: '/locations'
      path: '/locations'
      fullPath: '/locations'
      preLoaderRoute: typeof LocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/giveaways': {
      id: '/giveaways'
      path: '/giveaways'
      fullPath: '/giveaways'
      preLoaderRoute: typeof GiveawaysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gift': {
      id: '/gift'
      path: '/gift'
      fullPath: '/gift'
      preLoaderRoute: typeof GiftRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devices': {
      id: '/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof DevicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/success/$subscriptionId': {
      id: '/success/$subscriptionId'
      path: '/success/$subscriptionId'
      fullPath: '/success/$subscriptionId'
      preLoaderRoute: typeof SuccessSubscriptionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/renew/$subscriptionId': {
      id: '/renew/$subscriptionId'
      path: '/renew/$subscriptionId'
      fullPath: '/renew/$subscriptionId'
      preLoaderRoute: typeof RenewSubscriptionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/processing/$paymentId': {
      id: '/processing/$paymentId'
      path: '/processing/$paymentId'
      fullPath: '/processing/$paymentId'
      preLoaderRoute: typeof ProcessingPaymentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/countries/$subscriptionId': {
      id: '/countries/$subscriptionId'
      path: '/countries/$subscriptionId'
      fullPath: '/countries/$subscriptionId'
      preLoaderRoute: typeof CountriesSubscriptionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/$planId': {
      id: '/checkout/$planId'
      path: '/checkout/$planId'
      fullPath: '/checkout/$planId'
      preLoaderRoute: typeof CheckoutPlanIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityRoute: ActivityRoute,
  DevicesRoute: DevicesRoute,
  FaqRoute: FaqRoute,
  GiftRoute: GiftRoute,
  GiveawaysRoute: GiveawaysRoute,
  LocationsRoute: LocationsRoute,
  MeRoute: MeRoute,
  PaymentsRoute: PaymentsRoute,
  PlansRoute: PlansRoute,
  ProfileRoute: ProfileRoute,
  ReferralWithdrawRoute: ReferralWithdrawRoute,
  ReviewsRoute: ReviewsRoute,
  SettingsRoute: SettingsRoute,
  StatusRoute: StatusRoute,
  SubscriptionRoute: SubscriptionRoute,
  TopupRoute: TopupRoute,
  UpgradeRoute: UpgradeRoute,
  WalletRoute: WalletRoute,
  CheckoutPlanIdRoute: CheckoutPlanIdRoute,
  CountriesSubscriptionIdRoute: CountriesSubscriptionIdRoute,
  ProcessingPaymentIdRoute: ProcessingPaymentIdRoute,
  RenewSubscriptionIdRoute: RenewSubscriptionIdRoute,
  SuccessSubscriptionIdRoute: SuccessSubscriptionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
